import React from "react";

const CreateAlert = () => {
  return <div>This is create alert</div>;
};

export default CreateAlert;
